import React, { useEffect, useState } from 'react';
import { db } from '../firebase/firebase';
import { collection, getDocs } from 'firebase/firestore';
import { Table, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

function CampaignList() {
  const [campaigns, setCampaigns] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    async function load() {
      const snap = await getDocs(collection(db, "campaigns"));
      const arr = snap.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCampaigns(arr);
    }
    load();
  }, []);

  const columns = [
    { title: "ID", dataIndex: "id" },
    { title: "Titulo", dataIndex: "title" },
    {
      title: "Ações",
      render: (row) => (
        <Button type="primary" onClick={() => navigate(`/adminmaster9154874098490803320181572/${row.id}`)}>
          Editar
        </Button>
      )
    }
  ];

  return (
    <div style={{ padding: 24 }}>
      <h2>Painel Administrativo</h2>
      <Table dataSource={campaigns} columns={columns} rowKey="id" />
    </div>
  );
}

export default CampaignList;
